<template>
  <vz-card>
    <vz-loader :status-loader="orderStore.orderTotalPriceLoader || pageLoader" />

    <div class="vz-personal-order-total-card-item pt-30">
      <div class="vz-order-total-price-line mb-15">
        <div class="vz-order-total-price-line-service flex-align-items-center">
          <span class="text-h1 color-dark">Стоимость</span>
          <span class="vz-personal-order-total-card-item-buttons">
            <vz-button v-if="hasToggle" :icon-name="toggleIcon" rounded class="ml-5" @click="visible = !visible" />
          </span>
        </div>
      </div>
    </div>

    <div v-if="orderStore.costDisabledReason" class="vz-personal-order-total-card-item">
      <vz-order-total-price-cost class="vz-order-total-price-line" />
    </div>
    <template v-else>
      <div v-show="visible" class="vz-personal-order-total-card-item">
        <div
          v-for="(request, index) of orderStore.multiOrder.priceList"
          :key="index"
          class="vz-order-total-price-line mb-15"
        >
          <div class="vz-order-total-price-line-service">
            <span class="text-body color-dark" :title="`Заявка ${index + 1}`">
              Заявка {{ index + 1 }}
            </span>
            <span v-if="request.base" class="text-caption color-dark">
              {{ request.base }} {{ request.currencyMeasure }}
            </span>
          </div>
          <div v-if="request.total !== request.base" class="vz-order-total-price-line-discount">
            <span class="text-caption color-info2">
              Скидка
              <vz-tooltip-info
                v-if="request.action"
                :text="request.action"
              />
            </span>
            <span class="text-caption color-info2">{{ request.discount }} {{ request.currencyMeasure }}</span>
          </div>
        </div>
      </div>

      <hr v-show="visible" class="vz-individual-order-delimeter dashed">

      <div class="vz-personal-order-total-card-item">
        <template v-if="orderStore.orderForm.totalPrice?.total">
          <div v-for="totalPrice of orderStore.multiOrder.totalPriceList" class="mb-15">
            <div class="vz-order-total-price-line mb-10">
              <div class="vz-order-total-price-line-service">
                <span class="text-body color-dark">Всего</span>
                <span v-if="totalPrice.base" class="text-body color-dark">
                {{ totalPrice.base }} {{ totalPrice.currencyMeasure }}
              </span>
              </div>
            </div>
            <div v-if="totalPrice.discount" v-show="visible" class="vz-order-total-price-line mb-15">
              <div class="vz-order-total-price-line-service">
            <span class="text-body color-info2 flex flex-align-items-center">
              <span style="margin-right: 3px;">Скидки</span>
            </span>
                <span class="text-body color-info2">{{ totalPrice.discount }} {{ totalPrice.currencyMeasure }}</span>
              </div>
            </div>
            <div class="vz-order-total-price-line">
              <div class="text-subtitle color-dark mr-10">
                Итого:
              </div>
              <div class="text-h1 color-dark flex flex-align-items-center flex-wrap">
                <img :src="totalPrice.flag" class="mr-10" width="16" height="16">
                <span class="flex flex-align-items-center flex-nowrap">{{ totalPrice.total }} {{ totalPrice.currencyMeasure }}</span>
              </div>
            </div>
          </div>

          <div v-if="hideCostHint" class="text-caption color-light mb-10">
            Стоимость заказа может измениться при:
            <div>- изменении габаритов или веса груза после замера на терминале;</div>
            <div>- редактировании дополнительных услуг.</div>
          </div>
        </template>
        <div v-else class="vz-orders-item-payment-blocked vz-orders-item-payment-status color-success mb-10">
          {{ orderStore.payerText }}
        </div>
        <slot name="buttons" />
      </div>
    </template>
  </vz-card>
</template>

<script setup lang="ts">
import {useOrderStore} from '~/stores/order';
import VzOrderTotalPriceCost from '~/components/personal/order/vz-order-total-price-cost.vue';
import {storeToRefs} from 'pinia';
import {useLayoutStore} from '~/stores/personal/layout';
import VzCard from '~/components/ui-kit/vz-card.vue';
import VzLoader from '~/components/ui-kit/vz-loader.vue';
import VzButton from '~/components/ui-kit/vz-button.vue';
import VzTooltipInfo from '~/components/ui-kit/vz-tooltip-info.vue';
import {getCountryFlagIcon, getCurrencyText} from '~/common/objects';
import {Country} from '~/types/types';

const emit = defineEmits(['send-form', 'get-price'])

const props = defineProps({
  hasToggle: {
    type: Boolean,
    default: true
  },
})

const orderStore = useOrderStore()
const { pageLoader } = storeToRefs(useLayoutStore())

const visible = ref(true)

const hideCostHint = computed(() => {
  return !orderStore.orderForm?.meta?.taken
})

const currency = computed(() => {
  return orderStore.orderForm?.currency
})

const toggleIcon = computed(() => {
  return visible.value ? 'chevron-up' : 'chevron-down'
})

function onSendForm() {
  emit('send-form')
}

function onGetPrice() {
  emit('get-price')
}
</script>

<style lang="scss" scoped>
</style>

<style lang="scss">
</style>
